import styled from 'styled-components'

export const Container = styled.div`
  margin-bottom: ${props => props.theme.spacing.sp24};
`
